import { AnimationOnScroll } from "react-animation-on-scroll";
import { Link } from "react-router-dom";
import classes from "./Project.module.scss";

type PropsType = {
  title: string;
  subtitle: string;
  imgSrc: string;
  link: string;
};

const Project = (props: PropsType) => {
  const { title, subtitle, imgSrc, link } = props;

  return (
    <li className={classes.project}>
      <Link className={classes["project-link"]} to={link}>
        <div className={classes["project__img-wrapper"]}>
          <AnimationOnScroll animateIn={"animate__zoomIn"} offset={300} animateOnce>
            <img src={imgSrc} alt="" />
          </AnimationOnScroll>
        </div>
        <AnimationOnScroll animateIn={"animate__fadeInUp"} offset={50} animateOnce>
          <h3>{title}</h3>
          <p>{subtitle}</p>
        </AnimationOnScroll>
      </Link>
    </li>
  );
};

export default Project;
